import { AsyncPipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatAccordionTogglePosition, MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, Observable, Subject, share, switchMap, tap } from 'rxjs';
import { FacilityProfilesService } from 'src/app/facility-profiles/facility-profiles.service';
import { BillingInvoicing } from 'src/app/facility-profiles/models';
import { SanitizerPipe } from 'src/app/shared/pipes/sanitizer.pipe';

@UntilDestroy()
@Component({
    selector: 'nova-billing-invoicing',
    templateUrl: './billing-invoicing.component.html',
    styleUrls: ['../../../../styles.scss', './billing-invoicing.component.scss'],
    standalone: true,
    imports: [MatExpansionModule, MatProgressBarModule, AsyncPipe, SanitizerPipe]
})
export class BillingInvoicingComponent implements OnInit, OnDestroy {
    isLoading = false;

    @Input()
    facilityId: number;

    @Input()
    reloadBilling$: Observable<number>;

    @Input()
    editable = false;

    reload$ = new BehaviorSubject(true);
    billingInvoicing$: Observable<BillingInvoicing>;
    billingInvoicing: BillingInvoicing;
    expansionTogglePosition: MatAccordionTogglePosition = 'before';

    private readonly _cleanup$ = new Subject();

    constructor(private readonly _facilityProfilesService: FacilityProfilesService) {}

    ngOnInit(): void {
        this.billingInvoicing$ = this.reload$.pipe(
            tap(() => (this.isLoading = true)),
            switchMap(() => this._facilityProfilesService.getFacilityBillingInvoicing(this.facilityId)),
            tap((x) => {
                this.isLoading = false;
                this.billingInvoicing = x;
            }),
            share()
        );

        // Reload
        if (this.reloadBilling$) {
            this.reloadBilling$.pipe(untilDestroyed(this)).subscribe(() => this.reload$.next(true));
        }
    }

    ngOnDestroy(): void {
        this._cleanup$.next(true);
        this._cleanup$.complete();
    }
}
